<template>
    <div class="page-container">
        <!--工具栏-->
        <el-scrollbar>
        <el-form :inline="true" :model="filters" class="demo-form-inline toolbar" style="padding-bottom:0px;" :size="size">
            <!-- specialName -->
            <el-form-item label="是否上架">
                <el-select v-model="filters.show" clearable placeholder="请选择是否上架">
                <el-option label="未启用" value="0">未启用</el-option>
                <el-option label="已启用" value="1">已启用</el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <kt-button icon="el-icon-search" label="查询" type="primary" @click="findList()"/>
            </el-form-item>
            <!-- <el-form-item>
                <kt-button icon="el-icon-plus" label="新增" type="warning" @click="handleAdd"/>
            </el-form-item> -->
        </el-form>
        <div class="filtersposition"></div>
        </el-scrollbar>
        <!--表格内容栏-->
        
        <el-row>
            <el-table
              :data="tableData"
              class="worktable"
              style="width: 100%"
              :row-key="getRowKeys"
              :expand-row-keys="expands"
              :row-style="tableRowStyle"
              :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
              :header-cell-style="tableHeaderColor"
              @expand-change="expandChange">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-row v-for="item2 in props.row.servicePackageItemVos" :key="item2.serviceId">
                      <el-col :span="6">
                        <el-form-item label="服务项目名称：">
                          <span class="height40">{{ item2.name }}</span>
                        </el-form-item>
                      </el-col>  
                      <el-col :span="6">
                        <el-form-item label="项目金额：">
                          <span class="height40">{{ item2.price }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="收费方式：">
                          <span class="height40">{{  getCostTypeStr(item2.costType)}}</span>
                        </el-form-item>
                      </el-col>  
                      <el-col :span="6">
                        <el-form-item label="项目数量：">
                          <span class="height40">{{ item2.num }}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                  </el-form>
                </template>
              </el-table-column>
             
              <el-table-column
                prop="name"
                label="套餐名称"
                show-overflow-tooltip
                min-width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="orderSourceText"
                label="套餐主图"
                min-width="80"
                show-overflow-tooltip
                align="center"
              > 
              <template slot-scope="scope">
                  <el-image class="img" :preview-src-list="[scope.row.picture]" :src="scope.row.picture"/>
              </template>
            </el-table-column>
              <el-table-column
                prop="minTime"
                label="最低服务时长"
                min-width="100"
                show-overflow-tooltip
                align="center"
              >
              <template slot-scope="scope">
                 {{ scope.row.minTime }}分钟
              </template>
            </el-table-column>
              
              <el-table-column
                prop="specialName"
                label="专项名称"
                min-width="100"
                show-overflow-tooltip
                align="center"
              ></el-table-column>
              <el-table-column label="套餐原价" prop="originalPrice" min-width="80" align="center"></el-table-column>
              <el-table-column label="套餐总额" prop="price" min-width="80" align="center"></el-table-column>
              <el-table-column label="套餐备注" prop="remark" min-width="120" align="center" show-overflow-tooltip></el-table-column>
      
              <el-table-column
                prop="show"
                label="套餐状态"
                min-width="80"
                align="center"
              ></el-table-column>
              
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.row.orderStatus == 0 || scope.row.orderStatus == 6"
                      size="mini"
                      plain
                      type="success"
                      @click="handUn(scope.row)"
                      >下架</el-button>
                    <el-button
                      type="success"
                      size="mini"
                      v-else-if="scope.row.orderStatus == 5"
                      plain
                      @click="handOn(scope.row)"
                      >上架</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, prev, pager, next"
              :total="total"
              :page-size="pageSize"
              align="center"
              class="fenye"
            ></el-pagination>
          </el-row>

        <el-dialog
            title="查看套餐"
            width="500"
            :visible.sync="showDialogVisible">
            <el-form :model="showPackageForm"
                label-width="100px">
                <el-row>
                    <el-col :span="11">
                      <el-form-item label="套餐名称:" prop="name">
                        <el-input
                            v-model.trim="showPackageForm.name"
                            auto-complete="off"
                            readonly
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <el-form-item label="套餐备注:" prop="remark">
                        <el-input
                            v-model="showPackageForm.remark"
                            auto-complete="off"
                            readonly
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="11">
                      <el-form-item label="套餐价格:" prop="price">
                        <el-input
                            v-model.trim="showPackageForm.price"
                            auto-complete="off"
                            readonly
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <!-- <el-form-item label="是否上架:" prop="show">
                            <el-input
                            v-model.trim="showPackageForm.show"
                            auto-complete="off"
                            readonly
                            ></el-input>
                      </el-form-item> -->
                    </el-col>
                  </el-row>
            </el-form>
            <el-table
              :data="showServiceList"
              style="width: 95%; margin: 0 auto" >
              <el-table-column
                label="服务项目"
                prop="name"
              ></el-table-column>
              <el-table-column label="单价" prop="price"></el-table-column>
              <el-table-column label="数量" prop="num"></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog
            title="新增套餐"
            width="500"
            :visible.sync="addDialogVisible"
            :close-on-click-modal="false"
        >
            <el-form :model="addPackageForm"
                label-width="100px">
                <el-row>
                    <el-col :span="11">
                      <el-form-item label="套餐名称:" prop="name">
                        <el-input
                            v-model.trim="addPackageForm.name"
                            auto-complete="off"
                            placeholder="请输入套餐名称"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <el-form-item label="套餐备注:" prop="remark">
                        <el-input
                            v-model="addPackageForm.remark"
                            auto-complete="off"
                            placeholder="请输入备注"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="11">
                      <el-form-item label="套餐价格:" prop="price">
                        <el-input
                            type="number"
                            v-model.trim="addPackageForm.price"
                            auto-complete="off"
                            placeholder="请输入价格"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <!-- <el-form-item label="是否上架:" prop="show">
                        <el-switch
                              v-model="addPackageForm.show"
                              active-color="#13ce66"
                              style="margin-top:10px"
                              active-text="上架"
                              inactive-text="下架">
                            </el-switch>
                      </el-form-item> -->
                    </el-col>
                  </el-row>
            </el-form>
            <el-table
              ref="cartTable"
              :data="serviceList"
              style="width: 95%; margin: 0 auto"
              size="mini"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                align="center"
                width="55"
              ></el-table-column>
              <el-table-column
                label="服务项目"
                prop="serviceName"
              ></el-table-column>
              <el-table-column label="单价" prop="integral"></el-table-column>
              <el-table-column label="数量" width="220">
                <template slot-scope="scope">
                  <el-input-number
                    setp="1"
                    :min="1"
                    v-model="scope.row.num"
                    plain
                    v-on:change="calTotalPrice()"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" @click.native="addDialogVisible = false"
                  >取消</el-button
                >
                <el-button
                  :size="size"
                  type="primary"
                  @click.native="submitAddForm"
                  >确定</el-button
                >
              </div>
        </el-dialog>
    </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
    components: {
        KtButton
    },
    data() {
        return {
            loading: true,
            showListOptions: [],
            size: "medium",
            filters: {
                show: "",
            },
            filterColumns:[],
            expands: [], //表格展开的id集合
            pageResult: {},
            tableData:[],
            addPackageForm:{},
            multipleSelection: [],
            addDialogVisible:false,
            serviceList:[],
            showPackageForm:{},
            showServiceList:[],
            showDialogVisible:false,
            /* 分页的 */
            currentPage: 1, //初始页
            pageNum: 1, //页码
            pageSize: 10, //每页显示的条数
            total: 0, //数据的总数,
            groupId: "",
        };
    },
    methods: {
        /* 
          获取表格展开的id
        */
        getRowKeys: function (row) {
          return row.id;
        },
         /* 
          初始页currentPage、初始每页数据数pagesize和数据data
        */
        handleSizeChange(val) {
          console.log(`每页 ${val} 条`);
          //改变每页显示的条数
          this.PageSize = val;
          this.findList(); //刷新列表的数据
        },
        /* 
          当前页变化
        */
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`);
          this.pageNum = val;
          this.findList(); //刷新列表的数据
        },
        getCostTypeStr(type){
          if(type == 0){
            return "元/次"
          }else if(type == 1){
            return "元/小时"
          }else if(type == 2){
            return "元/分钟"
          }else if(type == 2){
            return "元/天"
          }else{
            return "元/月"
          }
        },
        formatType: function (row) {
          if(row.paymentMethod == 0){
            return "元/次"
          }else if(row.paymentMethod == 1){
            return "元/小时"
          }else if(row.paymentMethod == 2){
            return "元/分钟"
          }else if(row.paymentMethod == 2){
            return "元/天"
          }else{
            return "元/月"
          }
        },
        /* 
          展开和关闭表格的事件
        */
        expandChange(row, expandedRows) {
        },
        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
          if (rowIndex % 2 == 0) {
            return "background-color: #ffffff";
          } else {
            return "background-color: #e4f5f8";
          }
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0) {
            return "color:#2d2d2d;font-weight: 500; text-align: center;font-size: 14px;background-color: #efefef;";
          }
        },
        handUn(row){},
        handOn(row){},
        findList() {
            //判断查询条件是否存在
            this.$postJson("omc/servicePackage/queryPackagePage",{
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                isUse:this.filters.show||null
            }).then(res => {
                res.result.list.forEach(item =>{
                    if(item.isUse == 1){
                        item.show = "已启用"
                    }else{
                        item.show = "未启用"
                    }
                })
                this.tableData = res.result.list;

            });
        },
        calTotalPrice(){
            console.log(this.multipleSelection);
            let fee = 0;
            this.multipleSelection.forEach(item =>{
                fee = fee + item.num * item.integral
            })
            this.addPackageForm.fee = fee;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 时间格式化
        dateFormat(row, column, cellValue, index) {
            return format(row[column.property]);
        },
        // 跳转新增界面
        handleAdd() {
            this.addDialogVisible = true;
            this.addPackageForm = {
                show:false,
                name:'',
                price:0,
                remark:'',
                fee:0,
            };
            this.multipleSelection = [];
            this.$nextTick(() => {
                this.$refs.cartTable.clearSelection();
            });
        },
        submitAddForm(){
            console.log(this.addPackageForm);
            console.log(this.multipleSelection);
            if(this.addPackageForm.name == ''){
                this.$message({
                    message: "请输入套餐名称",
                    type: "error",
                });
                return;
            }
            if(this.addPackageForm.price == ''){
                this.$message({
                    message: "请输入套餐价格",
                    type: "error",
                });
                return;
            }
            var servicePackageItemVos = [];
            this.multipleSelection.forEach(item =>{
                if(item.num>0){
                    servicePackageItemVos.push({
                    serviceId:item.id,
                    name:item.serviceName,
                    num:item.num,
                    price:item.integral
                 })
                }
            })
            if(servicePackageItemVos == []){
                this.$message({
                    message: "请选择套餐项目",
                    type: "error",
                });
                return;
            }
            var params = {
                name:this.addPackageForm.name,
                price:Number(this.addPackageForm.price),
                remark:this.addPackageForm.remark,
                show:this.addPackageForm.show?1:0,
                fee:this.addPackageForm.fee,
                servicePackageItemVos:servicePackageItemVos
            }
            console.log(params);
            this.$postJson("omc/servicePackage/packageAdd", params).then(res =>{
                this.addDialogVisible = false;  
                if(res.code == 200){
                    this.findList();
                }
            })

        },
        //查看详情
        handleLook(info) {
            this.showDialogVisible = true;
            this.showPackageForm = Object.assign({}, info.row);
            this.$postForm("omc/servicePackage/packageItemShow",{packageId:info.row.id}).then(res =>{
                this.showServiceList = res.result;
            })

        },
        getServiceList(){
            this.$postJson("omc/service/queryListWithPage", {
                pageNum: 1, pageSize: 999
            }).then(res =>{
                var sList = [];
                res.result.list.forEach(item =>{
                    if(item.serviceType == 1){
                        sList.push(item);
                    }
                })
                this.serviceList = sList;
            })
        },
    },
    created() {
    },
    mounted() {
        this.findList();
    }
};
</script>
<style lang="scss" scoped>

.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }
  .demo-table-expand .el-form--inline .el-form-item__label {
    float: none;
    display: inline-block;
    color: #99a9bf;
    font-weight: 700;
  }
  ::v-deep .demo-table-expand{
    padding-left: 60px;
  }
  ::deep.height40 {
    height: 40px;
    line-height: 40px;
  }
  .colorBtn {
    background: rgb(165, 72, 241);
    color: #fff;
  }
    .avatar-uploader {
        width: 150px;
        height: 150px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 150px;
        height: 150px;
        display: block;
    }
    // ::v-deep深度作用选择符
    ::v-deep .el-dialog__header {
        text-align: left;
        background: rgb(238, 231, 231);
        border-bottom: 2px solid rgb(211, 207, 207);
    }
    //新增 编辑 dialog
    @media screen and (max-width: 1599px) {
        ::v-deep .volunteerdialog .el-dialog {
            width: 60% !important;
        }
    }
    ::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
        white-space: nowrap;
        width:100.5%;
        height:100%;
    }
    ::v-deep .el-form--inline{
        position: relative;
        z-index: 99;
    }
    .filtersposition{
        position: absolute;
        top:10px;
        left:0;
        right:0;
        bottom:10px;
        width:100%;
        height:56px;
        background: #F2F2F2;
        z-index:1;
    }
    .img{
      width:40px;
      height:40px;
    }
</style>